module.exports = __webpack_public_path__ + "2b02cf00ca66243b7512c959c52d3f69.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-11.png
// module id = 2588
// module chunks = 0